export const groupByProperty = <T, K extends keyof any>(
  arr: T[],
  key: (i: T) => K | undefined | null,
  defKey: string
) =>
  arr?.reduce((groups, item) => {
    (groups[key(item) || defKey] ||= []).push(item);
    return groups;
  }, {} as Record<K | string, T[]>);
